import { canUseDOM } from 'exenv';
import { get } from 'lodash';
import { fireActionTriggerCustomEvent } from '../events/pageEvents';

export const onPageView = (page = {}) => {
  // Note - see original concept for event history tracking example
  if (canUseDOM) {
    // window.digitalData = merge({}, window.digitalData, page.data.pageObject);
  }

  // Trigger custom event to notify Adobe Launch
  // fireActionTriggerCustomEvent('standard-page-view', {});

  // return for logging, adding to history, etc.
  return page;
};
onPageView.eventType = 'PAGE_VIEW';

export const defaultClick = (page = {}) => {
  // Note - see original concept for event history tracking example
  if (canUseDOM) {
    // Datalayer update not neccesary!
    // window.digitalData = merge({}, window.digitalData, page.data.eventObject);

    // Track as an EVENT in the data layer
    const eventInfo = get(window.digitalData, 'events', []);

    eventInfo.push({
      eventName: page.data.eventName,
      eventType: page.type,
      eventInfo: page.data.eventObject
    });
    window.digitalData.events = eventInfo;

    // Trigger custom event to notify Adobe Launch
    fireActionTriggerCustomEvent('default-click', {
      detail: page.data.eventObject
    });
  }

  // return for logging, adding to history, etc.
  return page;
};
defaultClick.eventType = 'DEFAULT_CLICK';

export const detectAdBlocker = (page = {}) => {
  // Note - see original concept for event history tracking example
  if (canUseDOM) {
    // Track as an EVENT in the data layer
    const eventInfo = get(window.digitalData, 'events', []);

    eventInfo.push({
      eventName: page.data.eventName,
      eventType: page.type,
      eventInfo: page.data.eventObject
    });
    window.digitalData.events = eventInfo;

    // Trigger custom event to notify Adobe Launch
    fireActionTriggerCustomEvent('adblocker-detected', {
      detail: page.data.eventObject
    });
  }

  // return for logging, adding to history, etc.
  return page;
};
detectAdBlocker.eventType = 'DETECT_AD_BLOCKER';
